export default __webpack_public_path__ + "static/media/pay1-points-img.941e6a31.svg";